var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
  'c-sidebar': true,
  'is-active': _vm.index > 0
}},[_c('div',{staticClass:"c-sidebar__nav"},_vm._l((14),function(n){return _c('div',{key:n,class:{
      'c-sidebar__item': true,
      'is-active': n  === _vm.index
    },on:{"click":function($event){$event.preventDefault();return _vm.goToSlide(n)}}},[(n < 13)?_c('span',{staticClass:"c-sidebar__item-count"},[_vm._v(" "+_vm._s(n)+" / 12 ")]):(n === 13)?_c('span',{staticClass:"c-sidebar__item-count"},[_vm._v(" "+_vm._s(_vm.afterword.sidebar)+" ")]):_c('span',{staticClass:"c-sidebar__item-count"},[_vm._v(" "+_vm._s(_vm.globals.share_label)+" ")]),_c('span',{staticClass:"c-sidebar__item-icon"})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }